import { gql, useQuery } from '@apollo/client';

const GET_PENDING_INSPECTIONS_COUNT = gql`
   query PendingInspectionsCount {
      pendingInspectionsCount
   }
`;

export const usePendingInspections = () => {
   const { data, loading, error, refetch } = useQuery(GET_PENDING_INSPECTIONS_COUNT, {
      pollInterval: 30000, // Poll every 30 seconds like notifications
      fetchPolicy: 'network-only',
   });

   return {
      pendingCount: data?.pendingInspectionsCount || 0,
      loading,
      error,
      refetch
   };
};